import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import CityPage from "@/pages/CityPage";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const LEGACY_REDIRECTS = {
    // old WordPress pages
    "/support": "/contact",
    "/contact-us": "/contact",
    "/products": "/",
    "/morningstarworld-com-sitemap": "/",
    "/interactive-panel-kerala": "/products/interactive-flat-panel-displays",
    "/kadambur-senior-secondary-school-kannur": "/products/interactive-flat-panel-displays",
    "/promethean-activpanel": "/products/interactive-boards",
    "/wide-angle-4k-usb-ptz-camera-for-video-conference": "/products/video-conferencing",
    "/echo-free-mic-for-conference": "/products/video-conferencing",
    "/white-colour-wall-mounted-active-speakers-with-crystal-clear-audio-output": "/products/sound-systems",
    "/notice-pin-up-display": "/products/writing-display-boards",
    "/wisdomatic-digital-rostrum-podium-lectern-classroom-lectern-kerala-classroom-rostrum-kerala-classroom-podium-kerala": "/products/digital-lectern",
    "/led-screen-display-how-to-install": "/products/led-video-wall",
    "/document-scanner-2": "/products/document-camera",
    "/led-video-wall-screen-led-display-indoor-led-outdoor-led-dot-pixel-led-active-led-advertising-led-board-rgb-led": "/products/led-video-wall",
    "/store": "/products/scrolling-led-boards",
    "/store/led-name-boards-c172016023": "/products/scrolling-led-boards",
    // old catalog products
    "/catalog": "/",
    "/catalog/indoor-outdoor-led-video-wall-kerala": "/products/led-video-wall",
    "/catalog/digital-lectern-podium-rostrum-for-classroom-lecture-hall-auditorium-kerala": "/products/digital-lectern",
    "/catalog/ptz-usb-remote-video-conference-camera-for-google-meet-microsoft-tems-zoom-webex-kerala": "/products/video-conferencing",
    "/catalog/wisdomatic-interactive-flat-panel-displays": "/products/interactive-flat-panel-displays",
    "/catalog/professional-conference-microphone": "/products/video-conferencing",
    "/catalog/conference-quality-speaker-for-google-meet-microsoft-teams-zooom-webex-excellent-audio-output": "/products/video-conferencing",
    "/catalog/church-led-scrolling-text-display-for-songs-and-bible-verses": "/products/scrolling-led-boards",
    "/catalog/scrolling-led-name-board-kochi-ernakulam-indoor-and-outdoor": "/led-display-boards/kochi",
    "/catalog/coaching-centre-video-studio": "/products/video-conferencing",
    // old FAQ entries
    "/faq/angekis-blade-vs": "/products/video-conferencing",
    "/faq/title-que-of-faq-1": "/",
    "/faq/how-to-connect-a-bluebee-fhd-webcam-2-0": "/products/video-conferencing",
    "/faq/can-i-improve-the-performance-of-android-whiteboard": "/products/interactive-flat-panel-displays",
    "/faq/can-i-use-finger-to-use-touch-features-or-to-write": "/products/interactive-flat-panel-displays",
    "/faq/how-many-operating-systems-can-be-used-with-bluebee-dolphin-ifpds": "/products/interactive-flat-panel-displays",
    "/faq/can-i-display-images-docs-or-videos-from-a-usb-pen-drive-on-bluebee-dolphin-displays": "/products/interactive-flat-panel-displays",
    "/faq/usb-cable-length-of-bluebee-interactive-board": "/products/interactive-boards",
    "/faq/i-want-to-use-a-simple-annotation-tool-with-my-powerpoint-and-use-it-like-a-whiteboard-too": "/products/interactive-boards",
};

const LegacyRedirect = () => {
    const { pathname } = useLocation();
    const key = pathname.replace(/\/+$/, "").toLowerCase();
    const target = LEGACY_REDIRECTS[key];
    if (target) return <Navigate to={target} replace />;
    return <Home />;
};

const BASENAME = window.location.pathname.startsWith("/kerala") ? "/kerala" : "/";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <HelmetProvider>
            <BrowserRouter basename={BASENAME}>
                <ScrollToTop />
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/products/:slug" element={<ProductPage />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/led-display-boards/:slug" element={<CityPage />} />
                        <Route path="*" element={<LegacyRedirect />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
